import styled from 'styled-components'

interface PageNumberProps {
  active?: boolean
}
interface PageNumberWrapperProps {
  isActive?: boolean
}

export const PagesPagination = styled.div`
  align-content: center;
  //margin-left: 450px;
  margin-top: 30px;
  justify-content: space-between;
  width: 150px;
  display: flex;
  margin-left: auto;
  margin-right: auto;
`
export const PageNumberWrapper = styled.div<PageNumberWrapperProps>`
  //color: #41aada;
  height: 26px;
  width: 26px;
  font-size: 16px;
  font-weight: bold;
  line-height: 19px;
  //&:active {
  color: ${props => (props.isActive ? '#ebeff5' : '#41aada')};
  background-color: ${props => (props.isActive ? '#41aada' : '')};
  border-radius: 50%;
  display: inline-block;
  //font-weight: bold;
  //margin-top: -5px;
  padding: 3px;
  //}
  //margin-top: -3px;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  label {
    cursor: pointer;
  }
`
export const PageIconWrapper = styled.div`
  //height: 26px;
  //width: 26px;
  //line-height: 19px;
  cursor: pointer;
`
export const Pages = styled.div`
  margin-left: 5px;
  margin-right: 5px;
  margin-top: -5px;
`
